import { Line } from "@nova/protobuf"
import { zoomToShowPoints } from "features/map/zoom/thunks"
import { createLine } from "features/pubsub/entityActions/cubes/line"
import store from "integrations/redux/store"
import { selectUserID } from "user/profile/selectors"
import { createDuplicatedEntityName } from "../module"
import { decideTakeSnapshotOfSecondaryLayer } from "features/map/control/module"

export const zoomToLine = (entity: Line) => {
    decideTakeSnapshotOfSecondaryLayer()
    store.dispatch(
        zoomToShowPoints({
            points: entity.coordinates.map(({ longitude, latitude }) => [longitude, latitude]),
        })
    )
}

export const duplicateLine = (entity: Line) => {
    const userId = selectUserID(store.getState())
    if (!userId) return

    store.dispatch(
        createLine({
            data: {
                coordinates: entity.coordinates,
                geometryType: entity.geometryType,
                width: entity.width,
                color: entity.color,
                outline: entity.outline,
                fill: entity.fill,
                stroke: entity.stroke,
                parentId: entity.parentId,
                holes: entity.holes,
                createdBy: { userId },
            },
            context: {
                name: createDuplicatedEntityName(entity.name),
            },
        })
    )
}
